var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPositionLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "436.8px",
    height: "566.9px",
    viewBox: "0 0 436.8 566.9",
    enableBackground: "new 0 0 436.8 566.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.4,
    y: 95.5,
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeMiterlimit: 10,
    width: 362.3,
    height: 402.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 95.5,
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    width: 362.7,
    height: 36.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 168.8,
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    width: 362.7,
    height: 36.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 242,
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    width: 362.7,
    height: 36.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 315.2,
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    width: 362.7,
    height: 36.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 388.4,
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    width: 362.7,
    height: 36.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43.2,
    y: 461.7,
    fill: "#D2D2D2",
    stroke: "#878787",
    strokeMiterlimit: 10,
    width: 362.7,
    height: 36.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 107.2,
    r: 2.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 116.9,
    r: 2.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 126.6,
    r: 2.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 136.2,
    r: 2.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 145.9,
    r: 2.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 155.5,
    r: 2.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 165.2,
    r: 2.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 174.9,
    r: 2.4
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 184.5,
    r: 2.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 194.2,
    r: 2.4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 203.8,
    r: 2.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 213.5,
    r: 2.4
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 223.1,
    r: 2.4
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 232.8,
    r: 2.4
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 242.5,
    r: 2.4
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 252.1,
    r: 2.4
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 261.8,
    r: 2.4
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 271.4,
    r: 2.4
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 281.1,
    r: 2.4
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 290.7,
    r: 2.4
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 300.4,
    r: 2.4
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 310.1,
    r: 2.4
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 319.7,
    r: 2.4
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 329.4,
    r: 2.4
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 339,
    r: 2.4
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 348.7,
    r: 2.4
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 358.3,
    r: 2.4
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 368,
    r: 2.4
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 377.7,
    r: 2.4
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 387.3,
    r: 2.4
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    fill: "#878787",
    stroke: "#878787",
    strokeMiterlimit: 10,
    cx: 25.6,
    cy: 397,
    r: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M25.6,439.7L25.6,439.7c-2.6,0-4.6-2.1-4.6-4.6 v-25.5c0-2.6,2.1-4.6,4.6-4.6l0,0c2.6,0,4.6,2.1,4.6,4.6v25.5C30.3,437.6,28.2,439.7,25.6,439.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "#878787",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M411.4,95.5H19.7C15,84.8,14.5,74,19.7,63h391.7 C417.6,73.9,417.6,84.7,411.4,95.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionLeft);
export default __webpack_public_path__ + "static/media/position_left.16230f1f7b1abae04d809bc157d89650.svg";
export { ForwardRef as ReactComponent };